'use client';

import React, { forwardRef } from 'react';
import { motion, type MotionProps } from 'framer-motion';
import { cn } from '@/lib/utils';
import ResponsiveWrapper, {
  type ResponsiveProperties,
} from './responsive-wrapper.tsx';

interface MainProperties extends ResponsiveProperties, MotionProps {
  id?: string;
  padding?: string;
  margin?: string;
  background?: string;
  className?: string;
}

const Main = forwardRef<HTMLDivElement, MainProperties>(
  (
    {
      id,
      padding = 'py-8 px-4',
      margin = 'm-0',
      background = '',
      sm,
      md,
      lg,
      className = '',
      children,
      ...props
    },
    ref,
  ) => {
    const mainClasses = cn('w-full', padding, margin, background, className);

    return (
      <ResponsiveWrapper sm={sm} md={md} lg={lg}>
        <motion.main ref={ref} id={id} className={mainClasses} {...props}>
          {children}
        </motion.main>
      </ResponsiveWrapper>
    );
  },
);

Main.displayName = 'Main';

export default Main;
